import { ThemeConfig } from 'antd'

export interface IConfig {
  id: 'default'
  config: Config
}

export enum configFeatures {
  AzureActiveDirectory = 'AzureActiveDirectory',
}

export type FeatureToggles = {
  [K in configFeatures]?: boolean
}

export class Config {
  constructor(raw: Partial<Config>) {
    this.features = {}
    Object.assign(this, raw)
  }

  readonly features: Readonly<FeatureToggles>

  isFeatureEnabled(feature: configFeatures): boolean {
    return !!this.features[feature]
  }
}

export const antConfig: { theme: ThemeConfig } = {
  theme: {
    components: {
      Menu: {
        iconSize: 21,
        activeBarHeight: 0,
      },
    },
  },
}
